import { FC } from "react";
import { useTranslation } from "react-i18next";
import RangeSlider from "../../components/range-slider";
import {
  AdminFormFieldCheckbox,
  AdminFormFieldInput,
} from "../../../../components/admin/formFields";
import { STEP_LABELS_OPTIONS, STEP_VALUES } from "../../constants";

interface ImpactProps {
  values: any;
  errors: any;
  touched: any;
  handleChange: (event: React.ChangeEvent<any>) => void;
  setFieldValue: (field: string, value: any) => void;
  handleBlur: (event: React.FocusEvent<any>) => void;
  setFieldTouched: (field: string, isTouched: boolean) => void;
}

const Impact: FC<ImpactProps> = ({
  values,
  errors,
  touched,
  handleChange,
  setFieldValue,
  handleBlur,
  setFieldTouched,
}) => {
  const { t } = useTranslation("translation", {
    keyPrefix: "camera.dashboard.management.sensor_event_detection",
  });
  const EVENT_TRIGGER_IMPACTS = [
    {
      id: "driving_impact",
      value: values.driving_impact,
      handleChange: handleChange,
    },
    {
      id: "parking_impact",
      value: values.parking_impact,
      handleChange: handleChange,
    },
  ];
  return (
    <>
      <div className="col-span-6 p-6 border-b space-y-1">
        <div className="w-full space-y-2 mb-4">
          <h1 className="text-lg text-accent-blue-dark font-bold mb-4">
            {t("impact")}
          </h1>
          <h2 className="block font-semibold text-sm leading-none tracking-normal">
            {t("event_trigger")}
          </h2>
          <p className="font-normal text-sm leading-none mb-4 text-gray-500">
            {t("event_trigger_description")}
          </p>
        </div>
        {EVENT_TRIGGER_IMPACTS?.map((impact, index) => (
          <RangeSlider
            key={impact.id}
            id={impact.id}
            min={STEP_VALUES.min}
            max={STEP_VALUES.max}
            step={STEP_VALUES.step}
            value={impact.value}
            onChange={impact.handleChange}
            stepLabels={STEP_LABELS_OPTIONS}
            isTopLabel={index === 0 ? true : false}
            isLeftLabel={true}
            leftLabel={t(impact.id)}
          />
        ))}
      </div>
      <div className="col-span-6 p-6 border-b space-y-1">
        <div className="w-full space-y-2 mb-4">
          <h2 className="block font-semibold text-sm leading-none tracking-normal">
            {t("event_recording")}
          </h2>
          <p className="font-normal text-sm leading-none mb-4 text-gray-500">
            {t("event_recording_description")}
          </p>
        </div>
        <div className="col-span-6 grid grid-cols-12 gap-6">
          <AdminFormFieldInput
            type="number"
            label={t("pre_event_video_duration_sec")}
            name="impact_pre_event_video_duration_sec"
            id="impact_pre_event_video_duration_sec"
            value={values.impact_pre_event_video_duration_sec}
            onChange={handleChange}
            onBlur={handleBlur}
            error={errors.impact_pre_event_video_duration_sec}
            touched={touched.impact_pre_event_video_duration_sec}
            customWrapperClass="col-span-6"
          />
          <AdminFormFieldInput
            type="number"
            label={t("post_event_video_duration_sec")}
            name="impact_post_event_video_duration_sec"
            id="impact_post_event_video_duration_sec"
            value={values.impact_post_event_video_duration_sec}
            onChange={handleChange}
            onBlur={handleBlur}
            error={errors.impact_post_event_video_duration_sec}
            touched={touched.impact_post_event_video_duration_sec}
            customWrapperClass="col-span-6"
          />
        </div>
      </div>
      {/* <div className="col-span-6 p-6 border-b space-y-1">
        <div className="w-full space-y-2 mb-4">
          <h2 className="block font-semibold text-sm leading-none tracking-normal">
            {t("auto_upload_to_portal")}
          </h2>
          <p className="font-normal text-sm leading-none mb-4 text-gray-500">
            {t("auto_upload_to_portal_description")}
          </p>
        </div>
        <div className="w-1/2 space-y-4">
          <div className="flex justify-between font-medium leading-none text-sm text-gray-500">
            <p>{t("media")}</p>
            <p>{t("g_sensor_and_gps_data")}</p>
          </div>
          <div className="flex justify-between font-medium leading-none text-sm">
            <p>{t("video")}</p>
            <p className="text-field-success">{t("on")}</p>
          </div>
        </div>
      </div> */}
      <div className="col-span-6 p-6 space-y-1">
        <h2 className="block font-semibold text-sm leading-none tracking-normal mb-4">
          {t("alerts")}
        </h2>
        <AdminFormFieldCheckbox
          customWrapperClass="w-1/2"
          label={t("in_cabin_audio_alert")}
          id="impact_in_cabin_audio_alert"
          type="checkbox"
          name="impact_in_cabin_audio_alert"
          checked={values.impact_in_cabin_audio_alert}
          onChange={handleChange}
          onBlur={handleBlur}
          error={errors.impact_in_cabin_audio_alert}
          touched={touched.impact_in_cabin_audio_alert}
        />
      </div>
    </>
  );
};

export default Impact;
